import { api } from "@contexts";
import type { Request, RequestDetail } from "@interfaces";
import { PrescriptionDocumentType } from "@interfaces";
import { groupBy } from "lodash/fp";

export interface CreatePrescriptionParams {
  request: Request;
  requestDetailData: RequestDetail[];
  signType?: "FEA" | "FES";
}

export async function createPrescription({
  request,
  requestDetailData,
  signType = "FEA",
}: CreatePrescriptionParams): Promise<void> {
  const prescriptionsAttributes = {
    doctorCode: request.doctorCode,
    requestId: request.id,
  };

  const filteredRequestDetails = requestDetailData.filter(
    (detail: RequestDetail) => detail.prescriptionType !== "CHECK",
  );

  // TODO: check typesafety of flow
  const groupedPrescriptions = groupBy((detail) => {
    // Group "SIMPLE", "NOT_REQUIRED", null and undefined in the same group
    const simpleGroup = ["SIMPLE", "NOT_REQUIRED", null, undefined];

    if (simpleGroup.includes(detail.prescriptionType)) return "SIMPLE";
    else return detail.prescriptionType;
  }, filteredRequestDetails);

  const simplePrescriptions = groupedPrescriptions["SIMPLE"] ?? [];
  const heldPrescriptions = groupedPrescriptions["HELD"] ?? [];

  const managementSummary = filteredRequestDetails
    .map((medicine: RequestDetail) => {
      return "name" in medicine && medicine.name
        ? medicine.name
        : medicine.activePrinciple;
    })
    .join(", ");

  await api({
    method: "post",
    url: `/requests/${request.id}/prescriptions`,
    data: {
      prescriptions: [
        ...(simplePrescriptions.length > 0
          ? [
              {
                ...prescriptionsAttributes,
                type: PrescriptionDocumentType.SIMPLE,
                details: simplePrescriptions,
              },
            ]
          : []),
        ...heldPrescriptions.map((heldPrescription) => ({
          ...prescriptionsAttributes,
          type: PrescriptionDocumentType.HELD,
          details: [heldPrescription],
        })),
      ],
      managementSummary,
      signType,
    },
  });
}
